import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_EMAILS_ROUTE_NAME = Symbol('admin.settings.emails');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_EMAILS = Symbol('general-settings.emails');

export const SETTINGS_EMAIL_TRIGGERS_LIST_URL = 'admin/mailers_manager/list';
export const SETTINGS_EMAIL_ITEM_URL = 'admin/mailers_manager/edit';
export const SETTINGS_EMAIL_SAVE_URL = 'admin/mailers_manager/save';

export const SETTINGS_EMAIL_TRIGGERS_LIST_QUERY_KEY = 'general-settings.email-triggers.list';
export const SETTINGS_EMAIL_ITEM_QUERY_KEY = 'general-settings.email.item';
export const SETTINGS_EMAIL_SAVE_QUERY_KEY = 'general-settings.email.save';

export const ADMIN_GENERAL_SETTINGS_EMAILS_PERMISSIONS = {
  MAILERS_MANAGER_EDIT: new Permission(PermissionsList.admin.MAILERSMANAGER_EDIT),
};
